import React from 'react';
import { type UseFormReturn } from 'react-hook-form';

import { type IPersonalDetailsSchema } from '../helper';
import { CardSection, ProfileFormSection, SummaryHeader, SummarySection } from '../styled';

interface ISummaryProps {
	hookForm: UseFormReturn<IPersonalDetailsSchema>;
}

const PrintPersonalInfo = ({ hookForm }: ISummaryProps) => {
	const values = hookForm.watch();
	const data = [
		{
			label: 'Name',
			value: values.firstName + ' ' + values.lastName,
		},
		{
			label: 'Email',
			value: values.email,
		},
		{
			label: 'Phone Number',
			value: values.phoneNumber,
		},
		{
			label: 'Gender',
			value: values.gender,
		},
		{
			label: 'Date of Birth',
			value: values.dateOfBirth,
		},
		{
			label: 'Voters Card ID',
			value: values.votersCardRegistrationNumber,
		},
	];
	return (
		<div>
			<SummaryHeader>
				<p className='header'>Personal Info</p>
			</SummaryHeader>
			<SummarySection>
				{data.map((dataItem) => (
					<CardSection key={dataItem.label}>
						<p className='label'>{dataItem.label}</p>
						<h5 className='value'>{dataItem.value}</h5>
					</CardSection>
				))}
			</SummarySection>
		</div>
	);
};

export default PrintPersonalInfo;
